import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { UpdateResultDto } from "../UpdateResultDto";
import { DisplayDeviceGroupDto } from "./DisplayDeviceGroupDto";

export class DeviceGroupUpdateResultDto extends DtoBase {

	public UpdateResult: UpdateResultDto;
	public Ddg: DisplayDeviceGroupDto;

	constructor() {
		super();

		this.UpdateResult = null;
		this.Ddg = null;
	}

	public Write(obj: any, context: any): void {
		obj.device_group_update_result = {};
		obj = obj.device_group_update_result;

		super.Write(obj, context);

		if (this.UpdateResult) {
			this.UpdateResult.Write(obj, context);
		}
		if (this.Ddg) {
			this.Ddg.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.device_group_update_result)
			throw new Error();
		obj = obj.device_group_update_result;

		super.Read(obj, context);

		if (obj.update_result !== undefined) {
			this.UpdateResult = new UpdateResultDto();
			this.UpdateResult.Read(obj, context);
		}
		if (obj.display_device_group !== undefined) {
			this.Ddg = new DisplayDeviceGroupDto();
			this.Ddg.Read(obj, context);
		}
	}

}